import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';

class TdDataFunc {
  static setting_data_at_td_data_arr = (inData: any) => {
    let opt_obj = {
      cal_data: {},
      td_data_arr: [],
      discover_info_arr: [],
      select_stu_seq_arr: [],
      open_write_discover_map: (inData: any) => { },
      ...inData,
    };
    let td_data_arr = opt_obj["td_data_arr"];
    let discover_info_arr = opt_obj["discover_info_arr"];
    let this_obj = this;

    for (let td_i = 0; td_i < td_data_arr.length; td_i++) {
      let td_data = td_data_arr[td_i];
      td_data_arr[td_i]["content"] = this_obj.get_td_content_of_td_data_arr({
        td_data: td_data,
        discover_info_arr: discover_info_arr,
        select_stu_seq_arr: opt_obj["select_stu_seq_arr"],
        open_write_discover_map: opt_obj["open_write_discover_map"],
      });
    }

    return td_data_arr;
  };
  static get_td_content_of_td_data_arr = (inData: any) => {
    let opt_obj = {
      td_data: {},
      discover_info_arr: [],
      select_stu_seq_arr: [],
      open_write_discover_map: (inData: any) => { },
      ...inData
    };
    let td_data = opt_obj["td_data"];
    let discover_info_arr = opt_obj["discover_info_arr"];

    let discover_cnt = 0;
    for (let i = 0; i < discover_info_arr.length; i++) {
      let discover_info = discover_info_arr[i];
      if (discover_info["a_date"] === td_data["date_str"]) {
        discover_cnt++;
      }
    };
    let content_str: any = "";
    if (discover_cnt) {
      content_str = (
        <div className="text-left"
          onClick={() => {
            if (discover_info_arr.length > 0) {
              opt_obj["open_write_discover_map"]({
                stu_seq: discover_info_arr[0]["a_stu_seq"],
                row_data: discover_info_arr[0],
                is_update: true,
              });
            }
          }}>
          {discover_cnt}건
        </div>
      );
    } else {
      if (opt_obj.select_stu_seq_arr.length > 0 && td_data["date_str"] >= DateFunc.get_date_format(new Date(), "Y-m-d")) {
        content_str = (
          <div className="text-center">
            <button className="btn btn-dark"
              onClick={() => {
                if (opt_obj.select_stu_seq_arr.length > 0) {
                  opt_obj["open_write_discover_map"]({
                    stu_seq: opt_obj.select_stu_seq_arr[0],
                    row_data:{
                      a_ymd:strFunc.uncomma(td_data["date_str"]).substring(0,8),
                      a_seq:"",
                      a_date:td_data["date_str"],
                    },
                    is_update: false,
                  });
                }
              }}>+</button>
          </div>
        );
      }
    }

    return content_str;
  };
}
export default TdDataFunc;